import jQuery from 'jquery';
import {AusCents, AusDollar, Euros, HashUrl, JsonDate} from "./types";
import {Promise} from "es6-promise";
import printf from "printf";
import PlainObject = JQuery.PlainObject;
import {Recording} from "../bo/recording";

/**
 * Obtain the HashUrl from the window. This omits the leading # (but should start with a /)
 */
export function windowHashUrl() : HashUrl {
    const hash = window.location.hash || "#";
    const url = hash.replace(/^#/, "");
    return url;
}

export function hashUrlToUrl(h: HashUrl) : string {
    const url0 = window.location.href;
    const url = url0.replace(/(#.*)?$/, "#" + h);
    return url;
}

/**
 * Obtain the parts of the HashUrl separated by /.
 * @param url
 */
export function path(url: HashUrl) : Array<string> {
    const url2 = url.replace(/^\//, "");
    const path = url2.split('/').map(s => decodeURIComponent(s));
    return path;
}

export function pushHash(h: HashUrl) {
    window.location.hash = (h ? "#" + h : "#");
}

export function replaceHash(h: HashUrl) {
    const url = hashUrlToUrl(h);
    window.history.replaceState(null, "", url);
}

export function formToJson(form: JQuery<HTMLElement>, json: any) {
    const formData = form.serializeArray();

    for (const i in formData) {

        const field = form.find("*[name='" + formData[i].name + "']");

        const valRaw = formData[i].value;

        // Type conversions:

        // If the field has class "number" then the value is parsed as a number.
        // Additionally if it has class "integer" then it is parsed as integer

        // Any checkboxes with the class "boolean" are serialized as either true or false.
        // Note that this is different to normal checkbox behaviour in which the
        // control is not submitted if not checked.

        const isNumber = field.hasClass("number");
        const isInteger = isNumber && field.hasClass("number");
        const isMoney = isNumber && field.hasClass("money");
        const isDate = field.hasClass("datefield");
        const isBoolean = field.hasClass("boolean");
        const isMultiple = field[0].nodeName == "SELECT" && field.attr("multiple") !== undefined;

        let val;

        if (isNumber) {

            let val0 = valRaw;

            if (isMoney && val0) {
                val0 = val0.replace("$", "");
            }

            const re = isInteger ? / *-?[0-9]+ */ : / *-?([0-9]+|[0-9]*\.[0-9]+ *)/;

            if (val0 != null && val0.match(re)) {
                val = Number(val0);
            } else {
                val = null;
            }

        } else if (isDate) {

            // Convert dd/mm/yyyy to yyyy-mm-dd
            if (valRaw && valRaw.match(/\//)) {
                val = parseDate(valRaw);
            } else {
                val = valRaw;
            }
        } else if (isBoolean) {

            // expected values are "true", "false" and "" (or null)
            if (valRaw === "true") {
                val = true;
            }
            if (valRaw === "false") {
                val = false;
            }

        } else {

            val = valRaw;

        }

        if (isMultiple) {

            if (json[formData[i].name] === undefined) {
                json[formData[i].name] = [];
            }
            if (json[formData[i].name].push) {
                json[formData[i].name].push(val);
            } else {
                // maybe name conflict? anyway we don't want to crash
                json[formData[i].name] = val;
            }

        } else {

            // normal case
            json[formData[i].name] = val;
        }


        // Now handle checkboxes of type boolean

        const booleans = form.find("input.boolean[type=checkbox]").not(":disabled");

        booleans.each((i, b) => {
            const name = jQuery(b).attr("name") as string;
            const val = jQuery(b).is(":checked") ? true : false;
            json[name] = val;
        });

    }

}

export const SESSION_COOKIE = "dksess";
const USER_COOKIE = "dkuser";


/**
 * Crude but effective to reload data (eg after update).
 * We can replace uses of this with something more sophisticated later.
 */
export function reloadWindow(url?: HashUrl) {
    if (! url) {
        window.location.reload();
    } else {
        const absUrl = window.location.href.replace(/#.*/, "") + "#" + url;
        window.location.href = absUrl;
        window.location.reload();
    }
}

export function openNewWindow(url: HashUrl) {
    const absUrl = window.location.href.replace(/#.*/, "") + "#" + url;
    window.open(absUrl);
}

/**
 * JsonDate is string for format yyyy-mm-dd.
 * We render as dd/mm/yyyy
 */
export function renderDate(d: JsonDate | undefined) {
    if (! d) {
        return d;
    }
    const bits = d.trim().split(/-/);
    return bits[2] + "/" + bits[1] + "/" + bits[0];
}

/**
 * Parse ddmmyyyy date into JsonDate (yyyy-mm-dd)
 * @param d
 */
export function parseDate(d: string | undefined) {
    if (! d) {
        return d;
    }
    const bits = d.trim().split(/\//);
    return bits[2] + "-" + bits[1] + "-" + bits[0];
}

/**
 * Render a unix timestamp as a time - eg "5 wrbminutes ago", "3 hours ago" or "24/02/2019",
 * depending on age.
 * @param ts
 */
export function renderTimestamp(ts: number) {
    const then = ts * 1000;
    const now = Date.now();

    const diff = now - then;

    // Segment rendering according to age:

    // < 1 hour - x minutes ago
    // < 24 hours - x hours ago
    // then dd/mm/yyyy

    const minutes = diff / 1000 / 60;
    const hours = minutes / 60;

    if (hours < 1) {
        const mins = Math.floor(minutes);
        return mins + " " + plural(mins, "minute", "minutes") + " ago";
    }
    if (hours < 24) {
        const h = Math.floor(hours);
        return h + " " + plural(h, "hour", "hours") + " ago";
    }

    function r(x: number) {
        const s = x.toString();
        return s.length < 2 ? "0" + s : s;
    }

    const d = new Date(then);
    return r(d.getDate()) + "/" + r(d.getMonth()+1) + "/" + r(d.getFullYear());
}

export function renderTimestampDay(ts: number) {
    const then = ts * 1000;
    const d = new Date(then);
    return d.getDate();
}
export function renderTimestampMonth(ts: number) {
    const then = ts * 1000;
    const d = new Date(then);
    const m = d.getMonth();
    return monthNames[m];
}


export function renderCents(cents: AusCents) : string {
    return printf((cents < 0 ? "-" : "") + "$%.2f", Math.abs(cents) / 100);
}

export function renderDollars(dollars: AusDollar) : string {
    return printf((dollars < 0 ? "-" : "") + "$%.2f", Math.abs(dollars));
}

export function renderEuros(euros: Euros) : string {
    return printf((euros < 0 ? "-" : "") + "%.2f€", Math.abs(euros));
}

export function unlimitedCredits(credits: number | undefined) {
    return credits !== undefined && credits > 100000;
}

export function renderCredits(credits: number) : string {
    if (unlimitedCredits(credits)) {
        return "unlimited TALC credits";
    } else if (credits == 1) {
        return "1 TALC credit";
    } else {
        return credits + " TALC credits";
    }
}

export function dollarsToCents(dollars: string | undefined) : number | undefined {
    let cents = undefined;
    dollars = dollars && dollars.replace("$", "");
    if (dollars && dollars.length > 0) {
        cents = Math.round(+dollars * 100);
    }
    return cents;
}

export const monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

export function plural(x: number, singular: string, plural: string) {
    return x == 1 ? singular : plural;
}

/**
 * A promise that is always already resolved with no value.
 */
export const emptyPromise = new Promise(((resolve, reject) => resolve()));

/**
 * A promise that is always resolved with the given value
 */
export function immediatePromise<T>(arg: T): Promise<T> {
    return new Promise(((resolve, reject) => resolve(arg)));
}

export function disable(button: JQuery<HTMLElement> | HTMLElement, promise: Promise<any>) {
    jQuery(button).prop("disabled", true);
    promise.finally(() => {
        jQuery(button).prop("disabled", false);
    });
}

export function pipe(x: PlainObject) : PlainObject {
    const json = JSON.stringify(x);
    const out = JSON.parse(json);
    return out;
}

export function loadExternalScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
        const scriptElement = document.createElement("script")
        scriptElement.src = scriptUrl
        scriptElement.onload = resolve
        document.body.appendChild(scriptElement)
    });
}

export function scrollTo(elt: JQuery<HTMLElement>, duration?: number) {
    if (duration === undefined) {
        duration = 100;
    }
    const offset = elt.offset();
    if (offset) {
        jQuery("html, body").animate({
            scrollTop: offset.top
        }, duration);
    }
}

export function shortGenre(genre: string | undefined) {
    switch (genre) {
        case "tango":
            return "T";
        case "vals":
            return "V";
        case "milonga":
            return "M";
        default:
            return "-";
    }
}

export function shortArtist(artist : string | undefined) {
    if (! artist) {
        return "";
    }

    const bits = artist.split(/, voc. /);

    function a(name: string) {
        const parts = name.split(/ /);
        const out: string[] = [];
        for (let i = 0; i < parts.length - 1; i++) {
            if (parts[i].length < 3) {
                out.push(parts[i]);
            }
        }
        out.push(parts[parts.length-1]);
        return out.join(" ");
    }

    return bits.map(a).join("/");
}

export function shortDate(d: string | undefined) {
    return d && d.replace(/([0-9]{4})-[0-9]{2}-[0-9]{2}/g, "$1");
}

export function tweakRecording(r: Recording) {
    const a : any = r;
    a.shortGenre = shortGenre(r.genre);
    a.shortArtist = shortArtist(r.artist);
    a.shortDate = shortDate(r.recording_date);
}

export function isInViewport(elt: JQuery<HTMLElement>) {

    // @ts-ignore
    const elementTop = elt.offset().top;
    // @ts-ignore
    const elementBottom = elementTop + elt.outerHeight();

    const viewportTop = jQuery(window).scrollTop();
    // @ts-ignore
    const viewportBottom = viewportTop + jQuery(window).height();

    // @ts-ignore
    return elementBottom > viewportTop && elementTop < viewportBottom;
}
